import { getRanaApiV1 } from "@nens/rana/api-v1";

export function getFolderTemplateQuery() {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["tenant-folder-template"],
    queryFn: async () => getRanaApiV1().FolderTemplatesApi.folderTemplateRetrieve({}),
  });
}
